// Single source of truth for the onboarding-tours feature flag.
// Controlled by TOURS_ENABLED in config/*.env.js. Webpack's DefinePlugin
// inlines the value as either a boolean literal (when defined as boolean
// in the env file) or a string ("true"/"false" when sourced from a local
// .env via dotenv) — accept both to be defensive.
export default function toursEnabled () {
  const v = process.env.TOURS_ENABLED
  return v === true || v === 'true'
}
